/**
 * BooleanControl — Toggle switch for boolean props.
 */

import { Switch } from '@/components/ui/switch'
import { Label } from '@/components/ui/label'

interface BooleanControlProps {
  value: boolean
  onChange: (v: boolean) => void
  label: string
}

export function BooleanControl({ value, onChange, label }: BooleanControlProps) {
  return (
    <div className="flex items-center justify-between py-1">
      <Label className="text-[13px] font-medium text-gray-600">{label}</Label>
      <Switch checked={value} onCheckedChange={onChange} />
    </div>
  )
}
